/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsexplainplans2Inputs */

const en_statsexplainplans2 = /** @type {(inputs: Statsexplainplans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans people created per day, without automatic repeats.`)
};

const de_statsexplainplans2 = /** @type {(inputs: Statsexplainplans2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pläne, die Menschen pro Tag erstellt haben, ohne automatische Wiederholungen.`)
};

/**
* | output |
* | --- |
* | "Plans people created per day, without automatic repeats." |
*
* @param {Statsexplainplans2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsexplainplans2 = /** @type {((inputs?: Statsexplainplans2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsexplainplans2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsexplainplans2(inputs)
	return de_statsexplainplans2(inputs)
});
export { statsexplainplans2 as "statsExplainPlans" }